import { z } from 'zod';
export const zipCodeSchema = z
    .string()
    .regex(/^\d{5}(-\d{4})?$/, 'Invalid zip code')
    .meta({ autocomplete: 'postal-code' });
